import type { FC, MouseEvent } from "react";

import { PageType } from "components/server-types";
import { t } from "i18n/i18n";
import { SquareButton } from "mds/components/buttons/SquareButton";
import { ChevronRightIcon, PresentPlayOutlineIcon } from "mds/icons";
import { FeatureStatus, featurePage } from "utils/presentation";

export type FeatureBreadcrumbsProps = {
  featureStatus: FeatureStatus | null;
  classSessionId: string;
  featureBlockId?: string;
  showSingleQuestionStep: boolean;
  page: PageType;
};

export const FeatureBreadcrumbs: FC<FeatureBreadcrumbsProps> = ({
  featureStatus,
  classSessionId,
  featureBlockId,
  showSingleQuestionStep,
  page,
}) => {
  const showingSingleQuestion = featureStatus === FeatureStatus.CLASS_RESPONSES_WITH_BLOCK;
  const showingSingleResponse = featureStatus === FeatureStatus.PARTICIPANT_RESPONSE_WITH_BLOCK;

  const onShowAllQuestions = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    featurePage(classSessionId, page, {
      blockId: null,
      accessId: null,
    });
  };

  const onShowSingleQuestions = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    featurePage(classSessionId, page, {
      blockId: featureBlockId,
      accessId: null,
    });
  };

  return (
    <div className="flex items-center gap-1 text-black-tint-20">
      <PresentPlayOutlineIcon className="mr-1 text-green" />

      <SquareButton
        eventName="Feature Modal - Breadcrumbs"
        kind="ghost"
        size="m"
        onClick={onShowAllQuestions}
      >
        {t("presentation.featuring.class_responses")}
      </SquareButton>

      {(showSingleQuestionStep || showingSingleQuestion) && (
        <>
          <ChevronRightIcon />

          <SquareButton
            disabled={showingSingleQuestion}
            kind="ghost"
            size="m"
            onClick={onShowSingleQuestions}
          >
            {t("presentation.featuring.individual_questions")}
          </SquareButton>
        </>
      )}

      {showingSingleResponse && (
        <>
          <ChevronRightIcon />

          {t("presentation.featuring.status.participant_response_with_block")}
        </>
      )}
    </div>
  );
};
